// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jAD3c","type":"styles_type__C2092","choices":"styles_choices__XAHjB"};